// src/pages/PortfolioPositionsPage.js
import React, { useState } from 'react';
import { usePortfolio } from '../contexts/PortfolioContext';
import { usePositions } from '../hooks/usePositions';
import PositionsTable from '../components/positions/PositionsTable';
import { Loader2, AlertCircle, AlertTriangle } from 'lucide-react';
import { collection, writeBatch, getDocs } from 'firebase/firestore';
import { db, auth } from '../services/firebase/config';
import { toast } from 'react-hot-toast';

function PortfolioPositionsPage() {
  const { selectedPortfolio: activePortfolio } = usePortfolio();
  const { positions, isLoading, error, updatePosition, deletePosition } = usePositions(activePortfolio);
  const [isDeletingAll, setIsDeletingAll] = useState(false);

  const handleDeleteAllPositions = async () => {
    if (!window.confirm('DİKKAT: Tüm pozisyonlar kalıcı olarak silinecektir. Bu işlem geri alınamaz! Devam etmek istediğinize emin misiniz?')) {
      return;
    }

    if (!window.confirm('Son bir kez onaylayın: Tüm pozisyonlarınız silinecek. Emin misiniz?')) {
      return;
    }

    if (!activePortfolio?.id || !auth.currentUser?.email) {
      toast.error('Portföy bilgilerine ulaşılamadı');
      return;
    }

    try {
      setIsDeletingAll(true);
      const batch = writeBatch(db);
      
      const positionsRef = collection(db, 
        'users', 
        auth.currentUser.email, 
        'portfolios', 
        activePortfolio.id, 
        'positions'
      );

      const snapshot = await getDocs(positionsRef);
      snapshot.docs.forEach(doc => {
        batch.delete(doc.ref);
      });

      await batch.commit();
      toast.success('Tüm pozisyonlar başarıyla silindi');
      window.location.reload(); // Sayfayı yenile
    } catch (error) {
      console.error('Toplu silme hatası:', error);
      toast.error('Pozisyonlar silinirken bir hata oluştu');
    } finally {
      setIsDeletingAll(false);
    }
  };

  if (!activePortfolio) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="bg-red-400/10 text-red-400 p-4 rounded-lg flex items-center gap-2">
          <AlertCircle className="h-4 w-4" />
          <span>Aktif portföy bulunamadı</span>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-6">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold text-gray-900 dark:text-white">
            {activePortfolio.name} - Pozisyonlar
          </h1>
          <div className="text-sm text-gray-500 dark:text-gray-400">
            Toplam Pozisyon: {positions.length}
          </div>
        </div>
        <p className="mt-2 text-gray-600 dark:text-gray-400">
          Portföy pozisyonlarınızı görüntüleyin ve düzenleyin.
        </p>
      </div>

      <div className="bg-white dark:bg-[#151934] shadow-sm rounded-lg p-6">
        {isLoading ? (
          <div className="flex justify-center items-center p-8">
            <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
          </div>
        ) : error ? (
          <div className="bg-red-400/10 text-red-400 p-4 rounded-lg flex items-center gap-2">
            <AlertCircle className="h-4 w-4" />
            <span>{error}</span>
          </div>
        ) : positions.length === 0 ? (
          <div className="text-center py-8 text-gray-500 dark:text-gray-400">
            Bu portföyde henüz pozisyon bulunmuyor.
          </div>
        ) : (
          <>
            <PositionsTable
              positions={positions}
              onUpdatePosition={updatePosition}
              onDeletePosition={deletePosition}
            />
            
            {/* Toplu Silme Butonu */}
            {positions.length > 0 && (
              <div className="mt-6 border-t border-gray-700 pt-4">
                <button
                  onClick={handleDeleteAllPositions}
                  disabled={isDeletingAll}
                  className="flex items-center gap-2 px-4 py-2 bg-red-500/10 hover:bg-red-500/20 text-red-500 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  <AlertTriangle className="w-4 h-4" />
                  <span>{isDeletingAll ? 'Siliniyor...' : 'Tüm Pozisyonları Sil'}</span>
                </button>
                <p className="mt-2 text-xs text-gray-500 dark:text-gray-400">
                  Bu işlem geri alınamaz. Tüm pozisyonlarınız kalıcı olarak silinecektir.
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default PortfolioPositionsPage;